import { get } from '@/api/request.ts';

async function fetchStatsApi() {
  const result = await get<{
    user_count: number;
    conversation_count: number;
    experiment_count: number;
    question_count: number;
    comment_count: number;
    message_count: number;
  }>(`/dashboard/stats/`);
  return result.data;
}

export { fetchStatsApi };
